class RouteUtil {

    static toRoute(route) {
        window.location.href = route;
    }

}

export default RouteUtil;